<plp-components-top-pagination class="top-pagination"></plp-components-top-pagination>

<!-- @if is used here to alias a single instance of the productListData$ as a single observable reference below -->
@if (productListData$ | async; as productListData) {
	<div class="product-grid hmf-px-s">
		@for (plpProduct of productListData.productVOs; track trackByFn($index, plpProduct)) {
			<div class="hmf-mb-m product-card hmf-display-flex hmf-flex-column">
				@if ((productListData.productDetails[plpProduct.parentCatentryId || plpProduct.catentryId]); as pld) {
					<a
						homefield-card
						padding="xs"
						[href]="(plpProduct.assetSeoUrl || plpProduct.dsgSeoUrl) + (pld.skuAttributes?.Color && pld.skuAttributes.Color.length > 0 ? '?color=' + pld.skuAttributes.Color[0] : '')">
						<div class="product-card-image">
							<homefield-product-image
								class="hmf-display-flex hmf-justify-content-center"
								[ecode]="plpProduct.parentPartnumber"
								[defaultColor]="pld.skuAttributes?.Color ? pld.skuAttributes?.Color[0] : ''"
								[productName]="plpProduct.name"
							></homefield-product-image>
						</div>

						<p class="product-description hmf-subheader-bold-m">
							{{plpProduct.name}}
						</p>
						<!-- Product price, price range, was price ( see price in cart )-->
						<div class="product-pricing hmf-mb-xs">
							<homefield-price
								[pricingInfo]="pld.prices"
								[isSeePriceInCart]="pld.mapPriceIndicator === 1"
								[isClearance]="pld.priceIndicator === 0"
							></homefield-price>
							<homefield-strikethrough-price
								[pricingInfo]="pld.prices"
								[isSeePriceInCart]="pld.mapPriceIndicator === 1"
								[isClearance]="pld.priceIndicator === 0"
							></homefield-strikethrough-price>
						</div>
					</a>
				}
			</div>
		}
	</div>
 }
<plp-components-bottom-pagination></plp-components-bottom-pagination>
